// extracted by mini-css-extract-plugin
export default {"iframe":"Viewer_iframe__C2HUN"};
    if(module.hot) {
      // 1763464084830
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  